import { MantineThemeOverride } from '@mantine/core';

export type AlertTheme = NonNullable<MantineThemeOverride['components']>['Alert'];

export const Alert: AlertTheme = {
  // todo: define
};
